import facepaint from "facepaint";

// See: https://tailwindcss.com/docs/responsive-design
const mediaQueries = facepaint([
  "@media (min-width: 640px)",
  "@media (min-width: 768px)",
  "@media (min-width: 1024px)",
  "@media (min-width: 1280px)",
  "@media (min-width: 1536px)",
]);

export default mediaQueries;
